<template>
  <div>
    <div>
      <aha-modal
        @hide="setPresentationNoPermission(null)"
        :title="$i18nPresenter.t('No access to presentation')"
        action-position="justify-center"
        :noCloseOnBackdrop="isEnableAddinPowerpoint"
        :closable="!isEnableAddinPowerpoint"
        :classesModal="{'ppt-request-presentation': isEnableAddinPowerpoint}"
      >
        <div v-if="!isEnableAddinPowerpoint">
          <div>
            {{ $i18nPresenter.t(
              'Please request the presentation owner to grant you access, or switch to an account that has access.'
            ) }}
          </div>
          <br />
          <div>{{ $i18nPresenter.t('You’re logged in as') }} <b>{{ currentUser.email }}</b>.</div>
        </div>

        <PowerPointRequestAccess
          :email="currentUser.email"
          :pptSubmitedRequestAccess="pptSubmitedRequestAccess"
          v-else
        />

        <template #action>
          <div>
            <div class="flex justify-end w-full" v-if="!pptSubmitedRequestAccess">
              <aha-antd-button
                v-aha-emit-action
                name="request-access"
                v-aha-click="requestAccessPresentation"
                :submitting="isLoadingRequestAccess"
                is-loading-inline
                class="mr-3"
              >
                {{ $i18nPresenter.t('Request access') }}
              </aha-antd-button>

              <aha-antd-button
                v-aha-emit-action
                name="switch-account-button"
                variant="secondary"
                v-aha-click="logout"
              >
                {{ $i18nPresenter.t('Switch account') }}
              </aha-antd-button>
            </div>
            <div v-if="isEnableAddinPowerpoint">
              {{ $i18nPresenter.t('For further support, please email us at') }}
              <a href="mailto:hi@ahaslides.com" class="text-primary-90 hover:text-primary-100">hi@ahaslides.com</a>
            </div>
          </div>
        </template>
      </aha-modal>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import util from '@/util'
import PresentationApi from '@/api/presentation'
import office from '@/services/office'
import PowerPointRequestAccess from '@/components-v2/my-presentations/PowerPointRequestAccess.vue'

export default {
  components: {
    PowerPointRequestAccess,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoadingRequestAccess: false,
      pptSubmitedRequestAccess: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      isEnableAddinPowerpoint: (state) => state.isEnableAddinPowerpoint,
    }),
    ...mapGetters('presentationsModule', ['requestAccessPresentationId']),
  },
  mounted() {
    this.subscribeRequestAccessSuccessAction({
      presentationId: this.requestAccessPresentationId,
      callback: this.handleAsyncAccessRequestCallBack,
    })
    document.body.classList.add('no-scroll')
  },
  destroyed() {
    document.body.classList.remove('no-scroll')
    const key = `/presentations/${this.requestAccessPresentationId}/access-requests`
    this.unsubscribeRequestAccessSuccessAction({ key })
  },
  methods: {
    ...mapActions('presentationsModule', ['setPresentationNoPermission']),
    ...mapActions(['subscribeRequestAccessSuccessAction', 'unsubscribeRequestAccessSuccessAction']),
    handleAsyncAccessRequestCallBack() {
      if (this.isEnableAddinPowerpoint) {
        office.handleDataAfterLoadOffice()
      }
    },
    logout() {
      this.setPresentationNoPermission(null)
      util.logout()
    },

    async requestAccessPresentation() {
      if (this.isLoadingRequestAccess) return
      this.isLoadingRequestAccess = true
      await PresentationApi.requestAccessPresentation({
        presentationId: this.requestAccessPresentationId,
      })
      this.isLoadingRequestAccess = false
      util.showToastSuccess(this.$i18nPresenter.t('Request sent. We will let you know if your request was approved.'))
      if (this.isEnableAddinPowerpoint) {
        this.pptSubmitedRequestAccess = true
        return
      }
      this.setPresentationNoPermission(null)
    },
  },
}
</script>

<style lang="scss">
.ppt-request-presentation {
  .aha-modal__content {
    width: 100%;
    height: 100%;
    border-radius: 0;
  }

  .aha-modal__body, .aha-modal__action {
    max-width: 480px;
    margin: 0 auto;
  }
  .aha-modal__header {
    display: none;
  }

  .aha-modal__action {
    justify-content: start;

    .justify-end {
      justify-content: flex-start;
      margin-bottom: 1.8rem;
    }
  }
}
</style>
